import React from 'react';
import NotFound from '../NotFound/NotFound';
import { useAppSelector } from '../../redux/hooks';
import AppLayout from '../../components/V1/Layouts/AppLayout/AppLayout';
import { LayoutType } from '../../utils/enums/layout-type.enum';
import Payments from './Payments';

export default function PaymentsWrapper() {
  const user = useAppSelector((state) => state.user);

  if (user.isNccUser) {
    return <NotFound />;
  }

  return (
    <AppLayout layout={LayoutType.DEFAULTV1}>
      <Payments />
    </AppLayout>
  );
}
